import CardColorBlock from "../../../components/cards/CardColorBlock/CardColorBlock";
import HighlightText from "../../../components/texts/HighlightText/HighlightText";
import Title from "../../../components/common/Title/Title";
import SEO from "../../../components/common/SEO/SEO";
import OptimizedImage from "../../../components/common/OptimizedImage/OptimizedImage";
import { useTranslation, Trans } from "react-i18next";

export default function CyberSecurity() {
    const { t } = useTranslation(['cyber-security']);

    const seo = t('seo', { returnObjects: true }) || {};
    const hero = t('hero', { returnObjects: true }) || {};
    const cards = t('cards', { returnObjects: true }) || {};
    const sections = t('sections', { returnObjects: true }) || {};

    return (
        <>
            <SEO
                title={seo.title}
                description={seo.description}
                url="https://www.aivhy.com/expertise/cyber-security"
                image="https://www.aivhy.com/images/logos/LOGO_AIVHY.webp"
            />
            <div className="main-container">
                <main className="head-content">
                    <div className="column-content-container height-container">
                        <Title text={hero.title} size={["4rem", "3rem", "2rem"]} level="h1" />
                        <HighlightText text={hero.tagline} size={["1.4rem", "1.2rem", "1rem"]} padding={["50px", "30px 24px", "20px"]} fontWeight="500" alignItems="flex-start"/>
                        <p className="paragraph-content">{hero.intro}</p>
                    </div>
                    <div className="cards-container">
                        <CardColorBlock iconClassName="fas fa-infinity" iconStyle={{ fontSize: "70px", color: "white" }} color={"var(--color-orange)"} title={cards.always?.title} text={cards.always?.text} />
                        <CardColorBlock image={"/images/icons/brain_white.webp"} color={"var(--color-blue)"} title={cards.iiot?.title} text={cards.iiot?.text} />
                        <CardColorBlock image={"/images/icons/secure_white.webp"} color={"var(--color-blue)"} title={cards.ot?.title} text={cards.ot?.text} />
                        <CardColorBlock iconClassName="fas fa-layer-group" iconStyle={{ fontSize: "70px", color: "white" }} color={"var(--color-blue)"} title={cards.holistic?.title} text={cards.holistic?.text} />
                    </div>
                </main>

                <section className="page-content-container">
                    <div className="row-content-container">
                        <div style={{ display: "flex", flexDirection: "column", gap: "10px", width: "100%"}}>
                            <Title text={sections.allWeDo?.title} size={["2rem", "1.8rem", "1.5rem"]}/>
                            <p className="paragraph-content">{sections.allWeDo?.body}</p>
                        </div>
                        <div style={{ display: "flex", flexDirection: "column", gap: "10px", width: "100%"}}>
                            <Title text={sections.digitalization?.title} size={["2rem", "1.8rem", "1.5rem"]} lineHeight={1.3}/>
                            <p className="paragraph-content">
                                <Trans
                                    i18nKey="sections.digitalization.body"
                                    ns="cyber-security"
                                    components={[<a className="text-link" href="/expertise/industrial4-0" />]}
                                />
                            </p>
                        </div>
                    </div>
                    <div className="row-content-container">
                        <div style={{ width: "100%", display: "flex", justifyContent: "center" }}>
                            <OptimizedImage 
                                src="/images/industries/wired.webp" 
                                className="wired-mask" 
                                alt="Wired"
                            />
                        </div>
                        <div style={{ width: "100%"}}>
                            <Title text={sections.otVsIt?.title} size={["2rem", "1.8rem", "1.5rem"]}/>
                            <div style={{ display: "flex", flexDirection: "column", gap: "10px" }}>
                                <p className="paragraph-content">{sections.otVsIt?.p1}</p>
                                <p className="paragraph-content">{sections.otVsIt?.p2}</p>
                                <p className="paragraph-content"><Trans i18nKey="sections.otVsIt.p3" ns="cyber-security" components={[<a className="text-link" href="/articles/ot-cyber-security" />]} /></p>
                            </div>
                        </div>
                    </div>
                </section>
            </div>
        </>
    );
}